import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { TruncatePipe } from './truncate.pipe';
import { FlCurrencyPipe } from './fl-currency.pipe';
import { SameDayPipe } from './same-day.pipe';
import { ChatDateDisplayPipe } from './chat-date-display.pipe';
import { MarkdownToHtmlPipe } from './markdown-to-html.pipe';
import { Sanitize } from './sanitize.pipe';
import { DisplayUrl } from './display-url.pipe';
import { IhCurrencyPipe } from './ih-currency.pipe';
import { WithUrlProtocol } from './with-url-protocol.pipe';

@NgModule({
  declarations: [
    ChatDateDisplayPipe,
    TruncatePipe,
    FlCurrencyPipe,
    SameDayPipe,
    MarkdownToHtmlPipe,
    Sanitize,
    DisplayUrl,
    IhCurrencyPipe,
    WithUrlProtocol
  ],
  imports: [CommonModule],
  providers: [DatePipe, DecimalPipe],
  exports: [
    ChatDateDisplayPipe,
    TruncatePipe,
    FlCurrencyPipe,
    SameDayPipe,
    MarkdownToHtmlPipe,
    Sanitize,
    DisplayUrl,
    IhCurrencyPipe,
    WithUrlProtocol
  ]
})
export class PipesModule {}
